import React, { createContext, useContext, ReactNode } from 'react';

interface ExportConfigContextType {
  overrideShouldIntercept: boolean;
}

const defaultContext: ExportConfigContextType = {
  overrideShouldIntercept: false
};

const ExportConfigContext = createContext<ExportConfigContextType>(defaultContext);

interface ExportConfigProviderProps {
  children: ReactNode;
  overrideShouldIntercept: boolean;
}

export const ExportConfigProvider: React.FC<ExportConfigProviderProps> = ({ 
  children, 
  overrideShouldIntercept 
}) => {
  return (
    <ExportConfigContext.Provider value={{ overrideShouldIntercept }}>
      {children}
    </ExportConfigContext.Provider>
  );
};

export const useExportConfig= () => {
  return useContext(ExportConfigContext);
}; 